/**
 * A const object rather than an `enum`: enum members are nominal, so the string literals
 * `@indeed/tare/spec/NativeJSTModel` produces would not be assignable to them.
 */
export const JSTOrientation = {
  PORTRAIT: "PORTRAIT",
  LANDSCAPE: "LANDSCAPE",
  UNDEFINED: "UNDEFINED",
} as const;

export type JSTOrientation = (typeof JSTOrientation)[keyof typeof JSTOrientation];

export interface JSTDeviceModelRecord {
  ctk: string | null;
  deviceId: string | null;
  manufacturer: string;
  manufacturerModel: string;
  orientation: JSTOrientation;
  osVersion: string;
}
